export const ARBITRUM_TOKEN_LIST = {
  name: 'KyberSwap Token List',
  keywords: ['dmmexchange', 'kyberswap'],
  timestamp: '2020-02-08T00:00:00+00:00',
  tokens: [
    {
      chainId: 42161,
      address: '0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8',
      symbol: 'USDC',
      name: 'USDC',
      decimals: 6,
    },
    {
      chainId: 42161,
      address: '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
      symbol: 'USDT',
      name: 'USDT',
      decimals: 6,
    },
    {
      chainId: 42161,
      address: '0xda10009cbd5d07dd0cecc66161fc93d7c9000da1',
      symbol: 'DAI',
      name: 'DAI',
      decimals: 18,
    },
    {
      chainId: 42161,
      address: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
      symbol: 'WETH',
      name: 'Wrapped Ether',
      decimals: 18,
    },
    {
      chainId: 42161,
      address: '0x2f2a2543b76a4166549f7aab2e75bef0aefc5b0f',
      symbol: 'WBTC',
      name: 'WBTC',
      decimals: 8,
    },
    {
      chainId: 42161,
      address: '0xFEa7a6a0B346362BF88A9e4A88416B77a57D6c2A',
      symbol: 'MIM',
      name: 'Magic Internet Money',
      decimals: 18,
      logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/162.png',
    },
  ],
  version: {
    major: 0,
    minor: 0,
    patch: 0,
  },
}
